import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["name", "value", "children", "className", "onValueChange", "defaultValue", "loop", "orientation"];
import { jsx } from 'react/jsx-runtime';
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import clsx from 'clsx';
import { forwardRef } from 'react';
import styles from './radio-group.module.js';
var RadioGroup = /*#__PURE__*/forwardRef(function (props, ref) {
  var name = props.name,
      value = props.value,
      children = props.children,
      className = props.className,
      onValueChange = props.onValueChange,
      defaultValue = props.defaultValue,
      loop = props.loop,
      orientation = props.orientation,
      rest = _objectWithoutProperties(props, _excluded);

  return jsx(RadixRadioGroup.Root, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    className: clsx([styles.root], _defineProperty({}, styles.horizontal, orientation === 'horizontal'), className),
    defaultValue: defaultValue,
    loop: loop,
    name: name,
    onValueChange: onValueChange,
    orientation: orientation,
    value: value,
    children: children
  }));
});
export { RadioGroup };